module.exports = __webpack_public_path__ + "img/20200104131510360截图20200104102108970.0dfc10d0.jpg";